import {
  FACHINTERESSENT_MY_DATA_CARD_DESCRIPTIONS,
  MEINE_AUFGABEN_CARD_ID,
  MY_DATA_CARD_ID,
  TENANT_ID,
} from 'global/constants';

import {
  getDEBPath,
  getDeleteCompanyPath,
  getMyTasksPath,
  getPrivacyPath,
  getSubAccountsPath,
} from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

const createTeaser = (description) => ({
  elementsList: [{ name: description }],
});

export const getFachinteressentMyDataCards = () => {
  const isBag = getTenantId() === TENANT_ID.BAG;

  return [
    {
      id: MY_DATA_CARD_ID.DATA_PRIVACY,
      title: 'Datenschutz',
      linkedPage: getPrivacyPath(),
      teaser: createTeaser(FACHINTERESSENT_MY_DATA_CARD_DESCRIPTIONS.DATENSCHUTZ),
    },
    {
      id: MY_DATA_CARD_ID.DATA_MANAGEMENT,
      title: isBag ? 'Datenerfassungsblatt' : 'Eintragung ändern/verlängern',
      linkedPage: getDEBPath(),
      teaser: createTeaser(FACHINTERESSENT_MY_DATA_CARD_DESCRIPTIONS.DATA_MANAGEMENT),
    },
    {
      id: MY_DATA_CARD_ID.SUB_ACCOUNTS,
      title: 'Zusatzkonten',
      linkedPage: getSubAccountsPath(),
      teaser: createTeaser('Hier können Sie Ihre vergebenen Zusatzkonten einsehen und verwalten.'),
    },
    {
      id: MEINE_AUFGABEN_CARD_ID,
      title: 'Meine Aufgaben',
      linkedPage: getMyTasksPath(),
      teaser: createTeaser('Offene Aufgaben'),
    },
    {
      id: MY_DATA_CARD_ID.DELETE_COMPANY,
      title: 'Firmeneintrag löschen',
      linkedPage: getDeleteCompanyPath(),
      teaser: createTeaser(FACHINTERESSENT_MY_DATA_CARD_DESCRIPTIONS.DELETE_PORTAL_ACCESS),
    },
  ];
};

export const enrichFachinteressentCardsWithAemIcons = (cards, aemCards) =>
  cards.map((card) => {
    const aemCard = aemCards.find(({ id }) => id === card.id);
    return aemCard?.icon ? { ...card, icon: aemCard.icon } : card;
  });
